import React, { Component } from 'react';

import analyticService from '../../../services/analytics';
import { getClass } from '../../../utils/component-helpers';
import { formatValue } from '../common/utils';

import DropdownList from './dropdown-list';

class DropdownMenu extends Component {
  constructor(props) {
    super(props);

    this.AnalyticService = analyticService;

    this.singleSelectionDropdowns = ['dateRanges', 'granularities', 'sorts'];
    this.allSelected = this.props.allSelected !== undefined ? this.props.allSelected : true;

    this.state = {
      searchTerm: '',
      allSelected: this.allSelected,
    };
  }

  reset(event) {
    event.stopPropagation();
    this.setState({ allSelected: !this.state.allSelected }, () => {
      this.props.resetColumns(this.state.allSelected);
    });
  }

  updateGuardrailCell(e) {
    /*
     * Uses the target's name to determine the part of state to update
     * (e.g guardrail_lower_bound => guardrailLowerBound)
     * Removes commas from update value and always adds a negative sign to values for lower bound
     */
    const newValue = e.target.value
      .split('')
      .reduce((acc, curr) => (/\d/g.test(curr) ? acc + curr : acc), '');
    const sign = e.target.name === 'guardrail_lower_bound' ? '-' : '';
    const formattedNewValue = sign + newValue;
    let field = e.target.name.split('_');
    field = field.reduce(
      (acc, curr, idx) => (!idx ? curr : acc + curr[0].toUpperCase() + curr.slice(1)),
      '',
    );
    this.props.updateField(field, parseInt(formattedNewValue));
  }

  render() {
    let search;
    let resetButton;
    const isMerchEdMerchantDropdown =
      this.props.statType === 'merch-ed-overview' && this.props.type === 'merchants';
    if (this.props.search) {
      search = (
        <div onClick={event => event.stopPropagation()}>
          <div className="search-icon"></div>
          <input
            className="search-input"
            type="text"
            placeholder={isMerchEdMerchantDropdown ? this.props.label : 'Search'}
            onChange={event => {
              if (isMerchEdMerchantDropdown) {
                this.props.setLabel(event.target.value);
              }
              this.setState({ searchTerm: event.target.value });
            }}
            value={this.state.searchTerm}
          />
        </div>
      );
      const resetText = this.state.allSelected ? 'Deselect All' : 'Select All';
      resetButton = (
        <button className="reset-btn" onClick={event => this.reset(event)}>
          {`${
            ['merchants', 'publishers'].includes(this.props.type) ? resetText : 'Restore Defaults'
          }`}
        </button>
      );
    }

    // Conditionally hide/display submit buttons.
    // NOTE: if hiding display buttons, the toggle dropdown function needs to handle
    let submitButtonText;
    if (isMerchEdMerchantDropdown) {
      submitButtonText = 'Search';
    } else if (this.props.type === 'reconSelections') {
      submitButtonText = 'Save';
    } else if (this.props.gaEvent.label === 'Payment Models Dropdown') {
      submitButtonText = 'Apply';
    } else {
      submitButtonText = 'Done';
    }
    const submitButtons =
      !this.props.hideSubmitButtons && !this.singleSelectionDropdowns.includes(this.props.type) ? (
        <>
          <button onClick={this.props.cancel} className="cancel-btn">
            Cancel
          </button>
          <button onClick={this.props.update} className="done-btn">
            {submitButtonText}
          </button>
        </>
      ) : null;

    const activeOnlyToggle = isMerchEdMerchantDropdown ? (
      <button className="active-only-btn" onClick={e => this.props.toggleState(e, 'activeOnly')}>
        Hide Inactive
        <div className={getClass('slider', { selected: this.props.activeOnly })}>
          <span></span>
        </div>
      </button>
    ) : null;

    const reconciledOnlyToggle = isMerchEdMerchantDropdown ? (
      <button
        className="reconciled-only-btn"
        onClick={e => this.props.toggleState(e, 'reconciledOnly')}
      >
        Hide Non-ROI Recon
        <div className={getClass('slider', { selected: this.props.reconciledOnly })}>
          <span></span>
        </div>
      </button>
    ) : null;

    const reconSelectionToggle =
      this.props.type === 'reconSelections' ? (
        <button
          className="recon-selection-btn"
          onClick={e => this.props.toggleState(e, 'reconAction')}
        >
          ROI Reconciliation
          <span className="slider-label">Enabled</span>
          <div className={getClass('slider', { selected: this.props.reconAction })}>
            <span></span>
          </div>
        </button>
      ) : null;

    let guardrailDisplay;
    if (this.props.type === 'reconSelections') {
      let editGuardrails;
      const formattedLowerBound = formatValue(
        this.props.guardrailLowerBound,
        'number',
        'guardrail_lower_bound',
      );
      const formattedUpperBound = `+${formatValue(
        this.props.guardrailUpperBound,
        'number',
        'guardrail_upper_bound',
      )}`;
      if (!this.props.reconAction) {
        editGuardrails = null;
      } else if (this.props.showEditGuardrails) {
        editGuardrails = (
          <form className="edit-guardrails" onClick={e => e.stopPropagation()}>
            <div>
              Minimum
              <div className="guardrail-lower-bound">
                <input
                  type="text"
                  value={formattedLowerBound}
                  name="guardrail_lower_bound"
                  onChange={this.updateGuardrailCell.bind(this)}
                />
                %
              </div>
            </div>
            <div>
              Maximum
              <div className="guardrail-upper-bound">
                <input
                  type="text"
                  value={formattedUpperBound}
                  name="guardrail_upper_bound"
                  onChange={this.updateGuardrailCell.bind(this)}
                />
                %
              </div>
            </div>
          </form>
        );
      } else {
        editGuardrails = (
          <div className="show-edit-guardrails">
            <span className="guardrails">Guardrails</span>
            <span>
              <span className="values">
                {formattedLowerBound}/{formattedUpperBound}%
              </span>
              <span className="edit" onClick={e => this.props.toggleState(e, 'showEditGuardrails')}>
                Edit
              </span>
            </span>
          </div>
        );
      }
      guardrailDisplay = (
        <>
          {editGuardrails}
          <div className="description">
            Edits will apply to all selected Merchants with EPP Pricing Models.
          </div>
        </>
      );
    } else {
      guardrailDisplay = null;
    }

    return (
      <div className="dropdown-menu">
        {search}
        {resetButton}
        {this.props.noResult}
        <div className="slider-btns">
          {activeOnlyToggle}
          {reconciledOnlyToggle}
          {reconSelectionToggle}
          {guardrailDisplay}
        </div>

        <DropdownList
          type={this.props.type}
          items={this.props.items}
          staticFields={this.props.staticFields}
          identifierField={this.props.identifierField}
          focusIndex={this.props.focusIndex}
          searchTerm={this.state.searchTerm}
          selectCallback={this.props.select}
          numSelected={this.props.numSelected}
        />
        {this.props.miscDropdownContent}
        {submitButtons}
      </div>
    );
  }
}

export default DropdownMenu;
